import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";

const listarSistemas = async () => {
    const requestOptions = {
        method: "GET",
        headers: AuthHeader(),
    };

    const response = await fetch(`${Url}sistemas/listar`, requestOptions);
    return HandleResponse(response);
};

export const SistemasServices = {
    listarSistemas,
};
